/**
 * WishFormModal Component
 * Modal wrapper for WishForm component used in desktop view
 */

import { useState } from 'react';
import Modal from '../common/Modal/Modal';
import WishForm from './WishForm';
import type { WishFormData } from './WishForm';
import { createWish } from '../../services/wishesApi';
import './WishFormModal.css';

interface WishFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (wishId: string) => void;
}

const WishFormModal = ({ isOpen, onClose, onSuccess }: WishFormModalProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (data: Omit<WishFormData, 'description' | 'district' | 'budget' | 'userPhone' | 'userEmail'> & {
    description?: string;
    district?: string;
    budget?: string;
    userPhone?: string;
    userEmail?: string;
  }) => {
    setIsLoading(true);
    setError('');

    try {
      const wishData = {
        title: data.title,
        description: data.description,
        category: data.category,
        region: data.region,
        district: data.district,
        budget: data.budget,
        urgent: data.urgent,
        userName: data.userName,
        userPhone: data.userPhone,
        userEmail: data.userEmail,
      };

      const result = await createWish(wishData);
      if (result) {
        onSuccess?.(result.id || '');
        onClose();
      } else {
        setError('發布許願失敗');
      }
    } catch (err) {
      console.error('Failed to save wish:', err);
      setError('發布許願失敗');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="large"
      bodyClassName="modal__body--wish-form"
      title="發布許願"
      desktopOnly={true}
    >
      <WishForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={isLoading}
        error={error}
      />
    </Modal>
  );
};

export default WishFormModal;
